import { customAxios, FDV_URL } from '../constants';

export default function(
  fdvID, codCia, codAreaVta, codFilial, codCliente,
  codTipoFicha, codMoneda, codVendedor, codTipoPago, observaciones
) {
  const data = {
    codCia,
    codAreaVta,
    codFilial,
    codCliente,
    codTipoFicha,
    codMoneda,
    codVendedor,
    codTipoPago,
    obsFichaVtaVeh: observaciones,
  };

  return customAxios.put(`${FDV_URL}/ficha-venta/fichas-venta/${fdvID}`, data);
}



// WEBPACK FOOTER //
// ./src/utils/editObservations.js